import { Link } from "react-router-dom";
import { Facebook, MapPin, Mail, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useContent } from "@/lib/content-store";
import { useDevotionalsOn } from "@/lib/display";

export const SiteFooter = () => {
  const CHURCH = useContent();
  const devOn = useDevotionalsOn();
  return (
  <footer className="bg-[#0A3A6B] text-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-[1.4fr_1fr_1fr] lg:px-10">
      <div>
        <Logo light />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-sky-100/80">
          Honoring God and making disciples — a church family in Parañaque.
        </p>
      </div>
      <div className="space-y-3 text-sm text-sky-100/90">
        <p className="text-xs font-semibold uppercase tracking-wider text-sky-300">Visit</p>
        <p className="flex gap-2"><MapPin className="h-4 w-4 shrink-0" /> {CHURCH.address}</p>
        <p className="flex gap-2"><Mail className="h-4 w-4 shrink-0" /> {CHURCH.email}</p>
        <p className="flex gap-2"><Phone className="h-4 w-4 shrink-0" /> {CHURCH.phone}</p>
      </div>
      <div className="space-y-3 text-sm">
        <p className="text-xs font-semibold uppercase tracking-wider text-sky-300">Connect</p>
        <a href={CHURCH.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook-link"
          className="flex items-center gap-2 text-sky-100/90 transition-colors hover:text-white">
          <Facebook className="h-4 w-4" /> Facebook
        </a>
        {devOn && <Link to="/devotionals" className="block text-sky-100/90 hover:text-white" data-testid="footer-devotionals-link">Daily Devotionals</Link>}
        <Link to="/staff" className="block text-sky-100/90 hover:text-white" data-testid="footer-staff-link">Staff Hub</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-sky-200/60">
      © {new Date().getFullYear()} {CHURCH.name}
    </div>
  </footer>
  );
};
